<template>
    <div>
        <table class="w-100 d-none d-md-table">
            <thead class="h-11 bg-lightGray">
            <tr class="font-bold">
                <td class="px-2">#</td>
                <td class="px-2">{{ $t('product.name') }}</td>
                <td class="px-2">{{ $t('unitOfMeasure.short') }}</td>
                <td class="px-2">{{ $t('productPriceModify.oldPrice') }}</td>
                <td class="px-2">{{ $t('productPriceModify.newPrice') }}</td>
                <td class="px-2">{{ $t('inventory.sumDifference') }}</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="piw of piwList" :key="piw.id" class="h-11">
                <td class="px-2">{{ piw.id }}</td>
                <td class="px-2 font-bold text-main" style="max-width: 250px">{{ piw.product.name }}</td>
                <td class="px-2">{{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</td>
                <td class="px-2">{{ showCurrencyById(piw.product.sellingPriceCurrency.id, piw.oldPrice) }}</td>
                <td class="px-2">{{ showCurrencyById(piw.product.sellingPriceCurrency.id, piw.newPrice) }}</td>

                <td class="px-2">
                    <div class="rounded py-1 text-center" :style="`background-color: ${howBgColor(parseFloat(piw.oldPrice) < parseFloat(piw.newPrice))}`">
                        <span>{{ parseFloat(Math.abs(piw.newPrice - piw.oldPrice).toFixed(2)) }}</span>
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) < parseFloat(piw.newPrice)"
                            class="icon-link-green"
                            :icon="['fa', 'arrow-up']"
                        />
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) > parseFloat(piw.newPrice)"
                            class="icon-link-red"
                            :icon="['fa', 'arrow-down']"
                        />
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <table class="w-100 d-md-none">
            <tbody  v-for="piw of piwList" :key="piw.id" style="border-bottom: 5px solid #444444">
            <tr class="h-11">
                <td class="px-2 font-weight-bold">#</td>
                <td class="px-2">{{ piw.id }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('product.name') }}</td>
                <td class="px-2" style="width: 50%">{{ piw.product.name }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('unitOfMeasure.short') }}</td>
                <td class="px-2">{{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('productPriceModify.newPrice') }}</td>
                <td class="px-2">{{ showCurrencyById(piw.product.sellingPriceCurrency.id, piw.oldPrice) }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('productPriceModify.newPrice') }}</td>
                <td class="px-2">{{ showCurrencyById(piw.product.sellingPriceCurrency.id, piw.newPrice) }}</td>
            </tr>
            <tr class="h-11">
                <td class="px-2 font-weight-bold">{{ $t('inventory.sumDifference') }}</td>
                <td class="px-2">
                    <div class="rounded py-1 text-center" :style="`background-color: ${howBgColor(parseFloat(piw.oldPrice) < parseFloat(piw.newPrice))}`">
                        <span>{{ parseFloat(Math.abs(piw.newPrice - piw.oldPrice).toFixed(2)) }}</span>
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) < parseFloat(piw.newPrice)"
                            class="icon-link-green"
                            :icon="['fa', 'arrow-up']"
                        />
                        <font-awesome-icon
                            v-if="parseFloat(piw.oldPrice) > parseFloat(piw.newPrice)"
                            class="icon-link-red"
                            :icon="['fa', 'arrow-down']"
                        />
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "ProductModifyItemListTable",
    mixins: [currencyFormatMixin],
    props: {
        piwList: {
            type: Array,
            required: true
        }
    },
    methods: {
        howBgColor(isPositive) {
            return isPositive ? '#D4F8E5' : '#FFCDB8'
        },
    }
}
</script>

<style scoped>

::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #6539B2;
}

.icon-link-red {
    color: red;
    font-size: 13px;
    position: relative;
    bottom: 3px;
    left: 5px;
}

.icon-link-green {
    color: #04f304;
    font-size: 13px;
    position: relative;
    bottom: 3px;
    left: 5px;
}

.checkmark-n {
    color: red;
    font-size: 22px;
    cursor: pointer;
}

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>
